import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'quill-table-better/dist/quill-table-better.css';
import 'quill2-emoji/dist/style.css';
import 'highlight.js/styles/atom-one-dark.css';
import 'katex/dist/katex.min.css';
import 'tom-select/dist/css/tom-select.default.css';
import controller_0 from '@symfony/ux-live-component/dist/live_controller.js';
import '@symfony/ux-live-component/dist/live.min.css';
import { Controller } from '@hotwired/stimulus';
export default {
  'ehyiah--ux-quill--quill': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@ehyiah/ux-quill/dist/controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'symfony--ux-autocomplete--autocomplete': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@symfony/ux-autocomplete/dist/controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'live': controller_0,
};